import React from "react";

// Category → color mapping (mengikuti kategori sales/marketing/etc)
const CATEGORY_STYLE = {
  core: "bg-slate-500/15 text-slate-300 border-slate-400/30",
  sales: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  marketing: "bg-pink-500/15 text-pink-300 border-pink-500/30",
  reports: "bg-sky-500/15 text-sky-300 border-sky-500/30",
  integration: "bg-violet-500/15 text-violet-300 border-violet-500/30",
  users: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  support: "bg-rose-500/15 text-rose-300 border-rose-500/30",
  other: "bg-white/10 text-white/60 border-white/10",
};

export function FeatureCategoryBadge({ category }) {
  const c = (category || "other").toLowerCase();
  const style = CATEGORY_STYLE[c] || CATEGORY_STYLE.other;
  return (
    <span
      data-testid={`feature-category-${c}`}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-black uppercase tracking-wider ${style}`}
    >
      {c}
    </span>
  );
}

// Source badge — untuk menunjukkan asal keputusan enabled/disabled.
const SOURCE_STYLE = {
  package: "bg-white/5 text-white/50 border-white/10",
  override: "bg-amber-500/15 text-amber-300 border-amber-500/30",
};

export function FeatureSourceBadge({ source }) {
  const s = (source || "package").toLowerCase();
  const style = SOURCE_STYLE[s] || SOURCE_STYLE.package;
  return (
    <span
      data-testid={`feature-source-${s}`}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${style}`}
    >
      {s}
    </span>
  );
}
